(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

/* eslint-disable no-nested-ternary,react/jsx-one-expression-per-line */
import React, { useCallback } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import useLanguage from "../../../Translation/hooks/useLanguage";
import Loading from "../../../../components/Loading";
import Table from "../../../../components/Table";
import HsCodesTree from "../../../../components/HsCodesTree";
import PhraseScore from "../PhraseScore";
import styles from "./SearchTable.module.css";
const SearchTable = /*#__PURE__*/React.memo(__signature__(props => {
  var _hsCodes$predictions, _hsCodes$predictions2, _hsCodes$predictions3;

  const {
    className,
    isLoading,
    hsCodes,
    colors,
    isRtl,
    onDownload,
    onProvideFeedback,
    hasError,
    isDeclare
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const {
    t
  } = useTranslation();
  const {
    language
  } = useLanguage();
  const goToDetails = useCallback(hsCode => () => {
    const pathname = location.pathname.replace(/\/$/, "");
    navigate({
      pathname: "".concat(pathname, "/").concat(hsCode),
      search: location.search
    }, {
      state: {
        action: "PUSH"
      }
    });
  }, [navigate, location]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.tableWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.downloadButtonContainer
  }, isDeclare && hsCodes && hsCodes !== null && hsCodes !== void 0 && (_hsCodes$predictions = hsCodes.predictions) !== null && _hsCodes$predictions !== void 0 && _hsCodes$predictions.length ? language === "am" ? /*#__PURE__*/React.createElement("span", {
    className: styles.status
  }, hsCodes && hsCodes.predictions.length === 1 ? t("result matching", {
    count: hsCodes && !isLoading ? hsCodes.predictions.length : 0
  }) : t("results matching", {
    count: hsCodes && !isLoading ? hsCodes.predictions.length : 0
  })) : /*#__PURE__*/React.createElement("span", {
    className: styles.status
  }, hsCodes && hsCodes.predictions.length === 1 ? t("result matching", {
    count: hsCodes && !isLoading ? hsCodes.predictions.length : 0
  }) : t("results matching", {
    count: hsCodes && !isLoading ? hsCodes.predictions.length : 0
  })) : null), isDeclare && !(hsCodes && hsCodes !== null && hsCodes !== void 0 && (_hsCodes$predictions2 = hsCodes.predictions) !== null && _hsCodes$predictions2 !== void 0 && _hsCodes$predictions2.length) ? /*#__PURE__*/React.createElement(React.Fragment, null, !isLoading && !hasError && /*#__PURE__*/React.createElement("div", {
    className: styles.resultWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.statusNotFound
  }, t("0 results found")))) : /*#__PURE__*/React.createElement(Table, {
    className: className
  }, /*#__PURE__*/React.createElement(Table.Header, {
    className: styles.tableHeader
  }, /*#__PURE__*/React.createElement(Table.Cell, {
    col: 5
  }, !isLoading && !hasError && /*#__PURE__*/React.createElement("div", {
    className: styles.resultWrapper
  }, hsCodes && hsCodes.useCas && /*#__PURE__*/React.createElement("span", {
    className: styles.useTypeTitle
  }, "CAS"), hsCodes && hsCodes.useGtin && /*#__PURE__*/React.createElement("span", {
    className: styles.useTypeTitle
  }, "GTIN"))), /*#__PURE__*/React.createElement(Table.Cell, {
    className: styles.headerCell,
    align: "right"
  }, t("Probability"), " %"), /*#__PURE__*/React.createElement(Table.Cell, {
    className: cx(styles.headerCell, styles.cellPhraseImportances),
    align: "right"
  }, t("Word importance"))), isLoading ? /*#__PURE__*/React.createElement(Table.Row, {
    className: styles.tableRow
  }, /*#__PURE__*/React.createElement(Loading, {
    color: colors.success
  })) : hsCodes && hsCodes.predictions.length ? (_hsCodes$predictions3 = hsCodes.predictions) === null || _hsCodes$predictions3 === void 0 ? void 0 : _hsCodes$predictions3.map(prediction => {
    var _prediction$children;

    return /*#__PURE__*/React.createElement(Table.Row, {
      key: prediction.hsCode,
      className: cx(styles.tableRow, styles.hsCodeRow),
      onClick: goToDetails(prediction.hsCode)
    }, /*#__PURE__*/React.createElement(Table.Cell, {
      col: 5
    }, /*#__PURE__*/React.createElement(HsCodesTree, {
      isRtl: isRtl,
      code: prediction.hsCode,
      description: prediction.hsDescription,
      colors: colors
    }, (_prediction$children = prediction.children) === null || _prediction$children === void 0 ? void 0 : _prediction$children.map(child => /*#__PURE__*/React.createElement(HsCodesTree.Child, {
      isRtl: isRtl,
      key: child.code,
      codeDetails: child,
      size: "sm"
    })))), /*#__PURE__*/React.createElement(Table.Cell, {
      align: "right"
    }, prediction.probability), /*#__PURE__*/React.createElement(Table.Cell, {
      align: "right",
      className: cx(styles.cellPhraseImportances, styles.phraseImportances)
    }, /*#__PURE__*/React.createElement(PhraseScore, {
      phraseImportances: prediction.phraseImportances
    })));
  }) : /*#__PURE__*/React.createElement(Table.Row, null, hasError && !window.navigator.onLine ? t("No Internet Connection please check your internet connection and try again") : t("Please describe your product in a different way to get results."))), !(hsCodes && hsCodes.predictions.length) && !isLoading && !hasError && !isDeclare && /*#__PURE__*/React.createElement("div", {
    className: styles.provideFeedbackContainer
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.provideFeedbackText
  }, "\uD83D\uDCA1", " ", t("Help us improve our system by")), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onProvideFeedback,
    className: cx(styles.provideFeedbackAction, {
      [styles.rtl]: isRtl
    })
  }, t("providing feedback")), "."));
}, "useNavigate{navigate}\nuseLocation{location}\nuseTranslation{{ t }}\nuseLanguage{{ language }}\nuseCallback{goToDetails}", () => [useNavigate, useLocation, useTranslation, useLanguage]));
SearchTable.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  hsCodes: PropTypes.object,
  colors: PropTypes.shape({
    info: PropTypes.string,
    success: PropTypes.string,
    secondary: PropTypes.string
  }).isRequired,
  isRtl: PropTypes.bool,
  onDownload: PropTypes.func.isRequired,
  onProvideFeedback: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  isDeclare: PropTypes.bool.isRequired
};
SearchTable.displayName = "SearchTable";
SearchTable.defaultProps = {
  className: null,
  hsCodes: null,
  isRtl: false
};
const _default = SearchTable;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SearchTable, "SearchTable", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/SearchTable/SearchTable.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/SearchTable/SearchTable.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();